import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PreventiveMaintenanceSummaryComponent } from './preventive-maintenance-summary';
import { PreventiveMaintenanceDetailComponent } from './preventive-maintenance-detail';
import { PreventiveMaintenanceCreateComponent } from './preventive-maintenance-create';
import { PreventiveMaintenanceEditComponent } from './preventive-maintenance-edit';
import { PreventiveMaintenanceAssignFormComponent } from './preventive-maintenance-assign-form/';
import { PreventiveMaintenancePdfAddComponent } from './preventive-maintenance-pdf-add/preventive-maintenance-pdf-add.component';
import { PreventiveMaintenancePdfSummaryComponent } from './preventive-maintenance-pdf-summary/preventive-maintenance-pdf-summary.component';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';


const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Preventive Maintenance'
    },
    children: [
      {
        path: 'summary',
        component: PreventiveMaintenanceSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'summary/:customerId',
        component: PreventiveMaintenanceSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: PreventiveMaintenanceDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: PreventiveMaintenanceEditComponent,
        data: { title: 'Edit' }
      },
      {
        path: 'assignForm',
        component: PreventiveMaintenanceAssignFormComponent,
        data: { title: 'Assign Form'}
      },
      {
        path: 'add',
        component: PreventiveMaintenanceCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'pdf/:pmId/:equipmentId', 
        data: { title: 'PDF'},
        children: [{
          path: 'a',
          component: PreventiveMaintenancePdfAddComponent,
          data: { title: 'Upload PDF' }
        }, {
          path: '',
          component: PreventiveMaintenancePdfSummaryComponent,
        }],
       
      }     
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreventiveMaintenanceRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-routing.module.ts